import { render, staticRenderFns } from "./localForm2.vue?vue&type=template&id=604c5ee8&scoped=true&"
import script from "./localForm2.vue?vue&type=script&lang=ts&"
export * from "./localForm2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c5ee8",
  null
  
)

export default component.exports